import cn from 'classnames'

const AnalyticsComponent = ({
    children,
    className = 'p-2 md:p-5 lg:px-10',
    h3ClassName,
    title,
}) => {
    return (
        <div>
            <div
                className={cn(
                    'w-full py-5 bg-zinc-50 dark:bg-zinc-900 rounded-2xl h-auto border-2 border-zinc-100 dark:border-zinc-800',
                    'shadow-md mb-10 AnalyticsComponent backdrop-blur-md',
                    className,
                )}
            >
                <h3
                    className={cn(
                        'mb-4 mt-0 text-2xl font-semibold',
                        h3ClassName,
                    )}
                >
                    {title}
                </h3>
                {children}
            </div>
        </div>
    )
}

export default AnalyticsComponent
